<template>
    <footer id="site-footer" data-v="1761926301">
        <div class="container" id="site-footer-c" data-v="1761926298">
            <div>
                <div class="row" id="footer-left-side" data-v="1761926295">
                    <div class="col-md-3">
                        <div>
                            <a class="navbar-brand" href="https://practice-german.online/en">
                                <!-- <img
                                    src="/images/logo/logo_30.avif"
                                    style="margin-top: -4px; width: 30px"
                                    width="20"
                                    height="20"
                                    alt="logo"
                                /> -->
                                <span class="logo">Practice German online</span>
                            </a>
                        </div>
                        <div class="mt-3 mb-3">
                            <p> Just the basics </p>
                            <p>Let me Know what you need: </p>
                        </div>
                        <!-- <address>
                            Head office: Frankfurter Allee 14, 10247.
                            <div>
                                Berlin, Germany
                            </div>
                        </address> -->
                        <div data-v="1760365834">office@practice-german.online</div>
                    </div>
                    <div class="col-md-3 relative" data-v="1761926292">
                        <!-- <a class="f-link pointer" :href="'/' +  hh.l('about')+'/about' ">About us</a> -->
                        <a class="f-link pointer" href="/en/about">About us</a>

                    </div>
                    <div class="col-md-2">
                    </div>
                    <div class="col-md-4">
                        <!-- <a
                            class="f-link"
                            href="/en/online-german-conversation-courses-by-level/a1?#int-3"
                        >
                            A1 -
                            <strong>Online german course</strong>
                        </a> -->

                    </div>

                    <div class="col-md-2 relative" data-v="1760363929">
                        <div id="footer-social">
                            <a href="mailto:office@practice-german.online" target="_black">
                                <!-- <img
                                    id="f-s-mail"
                                    class="ls-is-cached lazyloaded"
                                    data-src="/images/practice_german/footer/mail.avif"
                                    alt="envelope"
                                    width="27"
                                    height="19"
                                    src="/images/footer/mail.avif"
                                /> -->
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <hr />
        <div class="row g-0">
            <div class="col-6">
                <div class="ps-3">
                    <a class="font-12" href="/en/privacy">Privacy</a>
                    <a class="font-12 ps-4" href="/en/terms">Terms and Conditions</a>
                </div>
            </div>

            <div class="col-6">
                <span class="float-end pe-3">practice-german.online ©</span>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'footer-view',
    props: {
        hh: { type: Object, required: true }
    }
}
</script>

<style></style>